export const isFetchingUserPreferences = state =>
  state.ui.userPreferences.isFetching;

export const usersPreferencesUpdateErrors = state =>
  state.ui.userPreferences?.errors;
